import regex from "refractor/regex";
export default regex;